var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4132 10.6618L8.16325 16.9118C7.98713 17.0879 7.74826 17.1868 7.49918 17.1868C7.25011 17.1868 7.01124 17.0879 6.83512 16.9118C6.659 16.7357 6.56006 16.4968 6.56006 16.2477C6.56006 15.9986 6.659 15.7598 6.83512 15.5837L12.4218 9.9985L6.83668 4.41178C6.74948 4.32458 6.6803 4.22105 6.63311 4.10711C6.58591 3.99317 6.56162 3.87105 6.56162 3.74772C6.56162 3.62439 6.58591 3.50227 6.63311 3.38833C6.6803 3.27439 6.74948 3.17086 6.83668 3.08366C6.92389 2.99645 7.02742 2.92728 7.14136 2.88008C7.2553 2.83289 7.37742 2.80859 7.50075 2.80859C7.62408 2.80859 7.7462 2.83289 7.86014 2.88008C7.97408 2.92728 8.0776 2.99645 8.16481 3.08366L14.4148 9.33366C14.5021 9.42086 14.5713 9.52443 14.6185 9.63844C14.6657 9.75245 14.6899 9.87466 14.6898 9.99804C14.6896 10.1214 14.6651 10.2436 14.6177 10.3575C14.5702 10.4714 14.5007 10.5748 14.4132 10.6618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon2);
export default __webpack_public_path__ + "static/media/RightArrowIcon2.86df8271a78b07b0113ed922fa165605.svg";
export { ForwardRef as ReactComponent };